import React from 'react';

export const DownArrow = () => (
    <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.46571 3.79026L0.111419 0.611265C-0.126592 0.385693 0.0419803 0 0.37852 0L7.62144 0C7.95803 0 8.12659 0.385693 7.88859 0.611265L4.53426 3.79026C4.2392 4.06991 3.76077 4.06991 3.46571 3.79026Z" fill="#D2D3D7" />
    </svg>

)